import { Accept } from "react-dropzone/.";

const ADDRESS_DRAWER_WIDTH = 320;
const SM_WIDTH = 640;
const MD_WIDTH = 1024;
const LG_WIDTH = 1200;
const XL_WIDTH = 1536;
const XL_WIDTH_AUTO_MARGIN = 240;
const ADDRESSES_PER_PAGE = 3;
const ADDRESSES_PER_LARGE_PAGE = 5;

const DEFAULT_LOCALE = 'en-GB';

const OBJECT_KEY_ID = 'id';

const JOB_CODES_CACHE_KEY = 'jobCodes';
const STAFF_CACHE_KEY = 'staff';
const STAFF_ROLES_CACHE_KEY = 'staffRoles';
const LOCATIONS_ORGS_API_CACHE_KEY = 'orgsLocations';
const CATEGORIES_API_CACHE_KEY = 'categories';
const PRODUCTS_API_CACHE_KEY = 'products';

const CHARS_BEFORE_DECIMAL_POINT = 7;
const CHARS_AFTER_DECIMAL_POINT = 2;
const DEFAULT_STEP = 0.01;

const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png'];
const MAX_FILE_SIZE: number = 2.5 * 1024 * 1024;
const ACCEPT_PNG_JPG_JPEG: Accept = {
  'image/jpg': ['.jpg'],
  'image/jpeg': ['.jpeg'],
  'image/png': ['.png'],
};

const ACCEPT_XLSX_CSV: Accept = {
  'application/vnd.ms-excel': [],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
  'text/csv': [],
  'application/csv': [],
  'text/x-csv': [],
  'application/x-csv': [],
  'text/comma-separated-values': [],
  'text/x-comma-separated-values': [],
};

const DEFAULT_PAGE_SIZE = 50;

// Business types that will always send true as the restricted business value
const MANDATORY_RESTRICTED_INDUSTRY_TYPES = [7, 19, 23, 28, 30, 35, 71, 80];
// Business types that will show a checkbox for the client to choose if the business sells restricted items
const OPTIONAL_RESTRICTED_INDUSTRY_TYPES = [31, 32, 36, 37, 60, 64];

export {
  ADDRESS_DRAWER_WIDTH,
  SM_WIDTH,
  MD_WIDTH,
  LG_WIDTH,
  XL_WIDTH,
  XL_WIDTH_AUTO_MARGIN,
  ADDRESSES_PER_PAGE,
  ADDRESSES_PER_LARGE_PAGE,
  DEFAULT_LOCALE,
  OBJECT_KEY_ID,
  JOB_CODES_CACHE_KEY,
  STAFF_CACHE_KEY,
  STAFF_ROLES_CACHE_KEY,
  LOCATIONS_ORGS_API_CACHE_KEY,
  CATEGORIES_API_CACHE_KEY,
  PRODUCTS_API_CACHE_KEY,
  CHARS_BEFORE_DECIMAL_POINT,
  CHARS_AFTER_DECIMAL_POINT,
  DEFAULT_STEP,
  DEFAULT_PAGE_SIZE,
  MANDATORY_RESTRICTED_INDUSTRY_TYPES,
  OPTIONAL_RESTRICTED_INDUSTRY_TYPES,
  IMAGE_EXTENSIONS,
  MAX_FILE_SIZE,
  ACCEPT_PNG_JPG_JPEG,
  ACCEPT_XLSX_CSV
};
